import React from 'react';
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
type ChartDataPoint = {
  name: string;
  value: number;
  [key: string]: any;
};
type ProjectAnalyticsChartProps = {
  data: ChartDataPoint[];
  type: 'line' | 'bar' | 'pie';
  dataKeys: string[];
  colors?: string[];
  title?: string;
  xAxisLabel?: string;
  yAxisLabel?: string;
  height?: number;
};
export const ProjectAnalyticsChart: React.FC<ProjectAnalyticsChartProps> = ({
  data,
  type,
  dataKeys,
  colors = ['#4CAF50', '#8B4513', '#87CEEB', '#F5DEB3', '#7C0A02'],
  title,
  xAxisLabel,
  yAxisLabel,
  height = 300
}) => {
  const renderChart = () => {
    switch (type) {
      case 'line':
        return <ResponsiveContainer width="100%" height={height} data-id="element-131">
            <LineChart data={data} margin={{
            top: 10,
            right: 30,
            left: 0,
            bottom: 20
          }} data-id="element-132">
              <CartesianGrid strokeDasharray="3 3" stroke="#eee" data-id="element-133" />
              <XAxis dataKey="name" tick={{
              fontSize: 12
            }} label={xAxisLabel ? {
              value: xAxisLabel,
              position: 'insideBottom',
              offset: -10
            } : undefined} data-id="element-134" />
              <YAxis tick={{
              fontSize: 12
            }} label={yAxisLabel ? {
              value: yAxisLabel,
              angle: -90,
              position: 'insideLeft'
            } : undefined} data-id="element-135" />
              <Tooltip contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #ddd',
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }} data-id="element-136" />
              <Legend verticalAlign="top" height={36} data-id="element-137" />
              {dataKeys.map((key, index) => <Line key={key} type="monotone" dataKey={key} stroke={colors[index % colors.length]} strokeWidth={2} activeDot={{
              r: 6
            }} dot={{
              r: 4
            }} data-id="element-138" />)}
            </LineChart>
          </ResponsiveContainer>;
      case 'bar':
        return <ResponsiveContainer width="100%" height={height} data-id="element-139">
            <BarChart data={data} margin={{
            top: 10,
            right: 30,
            left: 0,
            bottom: 20
          }} data-id="element-140">
              <CartesianGrid strokeDasharray="3 3" stroke="#eee" data-id="element-141" />
              <XAxis dataKey="name" tick={{
              fontSize: 12
            }} label={xAxisLabel ? {
              value: xAxisLabel,
              position: 'insideBottom',
              offset: -10
            } : undefined} data-id="element-142" />
              <YAxis tick={{
              fontSize: 12
            }} label={yAxisLabel ? {
              value: yAxisLabel,
              angle: -90,
              position: 'insideLeft'
            } : undefined} data-id="element-143" />
              <Tooltip contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #ddd',
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }} data-id="element-144" />
              <Legend verticalAlign="top" height={36} data-id="element-145" />
              {dataKeys.map((key, index) => <Bar key={key} dataKey={key} fill={colors[index % colors.length]} radius={[4, 4, 0, 0]} data-id="element-146" />)}
            </BarChart>
          </ResponsiveContainer>;
      case 'pie':
        return <ResponsiveContainer width="100%" height={height} data-id="element-147">
            <PieChart data-id="element-148">
              <Pie data={data} cx="50%" cy="50%" labelLine={false} outerRadius={80} fill="#8884d8" dataKey="value" nameKey="name" label={({
              name,
              percent
            }) => `${name}: ${(percent * 100).toFixed(0)}%`} data-id="element-149">
                {data.map((entry, index) => <Cell key={`cell-${index}`} fill={colors[index % colors.length]} data-id="element-150" />)}
              </Pie>
              <Tooltip contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #ddd',
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }} data-id="element-151" />
              <Legend verticalAlign="bottom" height={36} data-id="element-152" />
            </PieChart>
          </ResponsiveContainer>;
      default:
        return <div data-id="element-153">Chart type not supported</div>;
    }
  };
  return <div className="w-full" data-id="element-154">
      {title && <h3 className="text-lg font-medium mb-3 text-soil-brown" data-id="element-155">{title}</h3>}
      {renderChart()}
    </div>;
};